/* eslint-disable */
var $bridge = {}
if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
  $bridge = require('./ios-bridge');
} else if(/(Android)/i.test(navigator.userAgent)) {
  $bridge = require('./android-bridge').default;
}
export default $bridge


